import React from 'react'
import "./managed.scss";
import { motion } from "framer-motion";
import Navbar from '../landing/header/Navbar';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Workflows from '../landing/workflows/Workflows';
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Headernew from '../landing/headernew/Headernew';
import ScheduleButton from '../landing/main-banner/ScheduleButton';
const Managed = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const cardVariants = {
        hidden: { opacity: 0, y: 40 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" },
        },
    };

    const options = {
        margin: window.innerWidth > 600 ? 20 : 10,
        loop: true,
        autoplay: window.innerWidth > 600 ? true : false,
        autoplayTimeout: window.innerWidth > 600 ? 2000 : null,
        autoplayHoverPause: window.innerWidth > 600 ? true : false,
        smartSpeed: 600,
        autoplaySpeed: 600,
        nav: true,
        dots: false,
        navText: [
            "<img src='/assets/left.svg'/>",
            "<img src='/assets/right.svg'/>",
        ],
        responsive: {
            0: { items: 1 },
            300: { items: 1.1 },
            400: { items: 1.1 },
            600: { items: 1.1 },
            1000: { items: 2.5 },
            1300: { items: 3.5 },
            1700: { items: 4.5 },
        },
    };

    const testimonials = [
        {
            name: "Network and Infrastructure Management",
            quote:
                "Sleep Easy: Your network is our watch. Our experts monitor and manage your network 24/7, ensuring optimized performance, reliability, and scalability.",
            img: "/assets/doone.svg",
        },
        {
            name: "Azure Services Management",
            quote:
                "Azure-Certified Expertise: Your Azure services will be managed by our team of Azure-certified professionals. We ensure your cloud journey with Azure is smooth, secure, and efficient, unlocking the full potential of Azure’s offerings for your business.",
            img: "/assets/dotwo.svg",
        },
        {
            name: "O365 Management and Support",
            quote:
                "Boost Your Productivity: Unleash the power of O365 apps with our management services. From setup to support, we tailor Office 365 applications to your business needs.",
            img: "/assets/dothree.svg",
        },
        {
            name: "Enhanced Endpoint Security",
            quote:
                "Endpoint Protection: We fortify your business against cyber threats with comprehensive endpoint security. Our advanced protocols safeguard against malware, phishing, and unauthorized access, ensuring your network and devices remain secure.",
            img: "/assets/dofour.svg",
        },

        {
            name: "Precise IT Asset and Inventory Management",
            quote:
                "Stay on Top: Keep track of your IT assets with our meticulous management services. From software licenses to hardware maintenance, we’ve got your IT inventory covered. ",
            img: "/assets/dofour.svg",
        },


        {
            name: "Reliable Helpdesk Support",
            quote:
                "Always Here for You: Experience uninterrupted operations with our 24/7 helpdesk support. Swift issue resolution, minimal downtime, and maximum productivity - that’s our promise.",
            img: "/assets/dofour.svg",
        },
    ];

    const cardsData = [
        {
            title: "Focus on Your Core Business",
            desc: "Let us handle your IT, so you can focus on what you do best - growing your business.",
            img: "/assets/paone.svg",
        },
        {
            title: "Managed IT Security Services",
            desc: "With a laser focus on Cyber Security, Disaster Recovery & Business Continuity Planning, we provide peace of mind with 24/7/365 monitoring.",
            img: "/assets/patwo.svg",
        },
        {
            title: "Predictable, Fixed Monthly Fee",
            desc: "Enjoy cost-effective access to enterprise-level support. No more break-fix as a service, experience increased operational efficiency.",
            img: "/assets/pathree.svg",
        },
        {
            title: "Proactive Maintenance",
            desc: "We’re always one step ahead. Our proactive approach identifies and resolves potential issues before they can impact your business.",
            img: "/assets/paone.svg",
        },
        {
            title: "Tailored IT Solutions",
            desc: "Every business is unique, and so are our services. Customized to meet your specific needs, we tackle your IT challenges head-on.",
            img: "/assets/patwo.svg",
        },
        {
            title: "Expert Team",
            desc: "Our certified IT professionals are not just skilled, they’re passionate about driving businesses forward. With 24/7 monitoring and support, we’re always there when you need us.",
            img: "/assets/pathree.svg",
        },
    ];


    return (
        <>
            <section className="main-banner security_main">
                <Headernew />
                <video
                    className="main-banner-video"
                    muted
                    playsInline
                    autoPlay
                    loop
                    width="100%"
                    id="myVideo"
                >
                    <source src="/assets/bannervideo.mp4" type="video/mp4" />
                </video>

                <div className="custom-container1">
                    <div className="top_banner">
                        <motion.h3
                            initial={{ x: -100, opacity: 0 }}
                            whileInView={{ x: 0, opacity: 1 }}
                            viewport={{ once: false }} // 👈 animation runs every time on scroll
                            transition={{ duration: 1 }}
                        >Managed IT Services
                        </motion.h3>


                    </div>
                    <motion.h4
                        initial={{ x: -100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        viewport={{ once: false }} // 👈 animation runs every time on scroll
                        transition={{ duration: 1 }}
                    >    <div className='elevate_mains   lastauses'>
                            <h4>Elevate your IT experience to worry-free heights with our all-inclusive Managed IT Services.</h4>
                            <p>Gain unparalleled access to a suite of services designed to optimize your operations, secure your data, and ensure your technology infrastructure not only meets but exceeds industry standards. </p>
                        </div>
                    </motion.h4>
                </div>
            </section>
            <div className='marque_div'>
                <h3>Trusted By Clients Across Industries</h3>
                <div className="trendinganimations">
                    <div className="trendinganimationsright">
                        <div className="marquee">
                            <div className="marquee__group">
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\3.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\4.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\5.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\6.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\7.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\8.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\9.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\10.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>

                                <div>
                                    <img className='imgunder' src="\assets\11.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\12.png" />
                                </div>






                            </div>
                            <div aria-hidden="true" className="marquee__group">
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\3.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\4.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\5.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\6.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\7.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\8.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\9.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\10.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>


                                <div>
                                    <img className='imgunder' src="\assets\11.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\12.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className='nnew_cardfss'>
                <div className='custom-container1'>

                    <div className='challenge'>
                        <h5>Common IT Management Problems We Solve</h5>
                        <div className='eight_cards111'>
                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Inefficient Office 365 Utilization</h6>
                                <p>Optimize use, simplify setup, and support adoption across teams.</p>
                            </div>
                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Vulnerable Endpoints</h6>
                                <p>Protect laptops, mobiles, and home setups from cyber attacks.</p>
                            </div>
                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Unmanaged IT Assets</h6>
                                <p>Track devices, control costs, and ensure compliance effortlessly.</p>
                            </div>

                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Extended IT Downtime</h6>
                                <p>Deliver responsive 24/7 support to keep operations running.</p>
                            </div>
                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Unreliable Network Infrastructure</h6>
                                <p>Monitor and manage infrastructure to prevent costly disruptions.</p>
                            </div>

                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Underutilized Azure Capabilities</h6>
                                <p>Implement best practices to boost efficiency and security in the cloud.</p>
                            </div>


                        </div>
                        <h3>What if we could manage your IT end-to-end?<br></br>
                            So you stay focused on growing your business, not fixing issues?</h3>
                    </div>

                </div>

            </div>
            <section className="slider_Div lassst_div">




                <h5>What We Offer</h5>

                <div className="cardshead">
                    <OwlCarousel className="owl-theme" {...options}>
                        {testimonials.map((t, i) => (
                            <motion.div
                                key={i}
                                className="cards"
                                variants={cardVariants}
                                initial="visible"
                                whileInView="visible"
                                viewport={{ once: false, amount: 0.4 }} // replay on every scroll‑in
                            >
                                <img className="imgggg" src={t.img} alt={t.name} />                <h2>{t.name}</h2>
                                <h3>{t.title}</h3>
                                <p>“{t.quote}”</p>
                            </motion.div>
                        ))}
                    </OwlCarousel>
                </div>
            </section>


            <section className='secure_main1'>
                <img src='/assets/elipses.png' className='elipses' alt='background design' />
                <div className='custom-container1'>
                    <div className='inner_secure'>
                        <h3>Why TechSecure360?

                        </h3>
                        <div className='parent_four_cards newone'>
                            {cardsData.map((card, index) => (
                                <motion.div
                                    className='onne_card'
                                    key={index}
                                    custom={index}
                                    variants={cardVariants}
                                    initial='hidden'
                                    whileInView='visible'
                                    viewport={{ once: false, amount: 0.3 }} // triggers on scroll in & out
                                >
                                    <div>
                                        <h4>{card.title}</h4>
                                        <p>{card.desc}</p>
                                    </div>
                                    <img src={card.img} alt={card.title} />
                                </motion.div>
                            ))}
                        </div>


                    </div>
                </div>
                <p className='textdiv'>With TechSecure360, you’re not just running your business, you’re securing your future. Let’s embark on this journey together!</p>
            </section>


            <div className='sub_mains'>
                <div className='custom-container1'>
                    <h3>Managed IT Subscriptions</h3>

                    <div className='two_cardsmains'>
                        <div className='leftsidecards newcards'>
                            <img src='\assets\shadee.png' className='shadeneww' />
                            <h4>Compliance Starter</h4>
                            <h5 className='anothhher_Side'>$799/Month <span>Perfect for small businesses or startups that need essential IT services to get up and running</span></h5>

                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Setup and basic support for Office 365 applications
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Basic Azure setup and monitoring.

                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Fundamental security measures to protect your data.
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Basic protection against malware, phishing, and unauthorized access.
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Business hours support for IT queries and troubleshooting.
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Monthly reporting on major IT assets.
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Monthly proactive maintenance and a quarterly review of IT performance
                            </h6>
                            <Link to="/contactus">
                                <button className='bluebutton'>Contact Us</button>
                            </Link>
                        </div>

                        <div className='rightsidecards newcards'>
                            <h4>Pro Package</h4>
                            <h5 className='anothhher_Side'>$1399/Month <span>Designed for established businesses looking for comprehensive IT management and proactive support</span></h5>

                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Full setup, customization, and support for Office 365 applications.


                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Comprehensive Azure management, including performance and security assessments.

                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Enhanced security protocols and incident response.
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Comprehensive IT Asset & Inventory Management
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Priority Helpdesk Support

                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Detailed asset tracking, maintenance scheduling, and bi-weekly reports.
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Customized security IT & security awareness trainings
                            </h6>
                                  <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Customized IT Solutions Tailored to Your Business
                            </h6>

                            <Link to="/contactus">
                                <button className='whitebutton'>Contact Us</button>
                            </Link>
                        </div>
                    </div>
                </div>

            </div>
            <section className='work_main'>
                {/* Background Shade Image */}
                <motion.img
                    src='/assets/shade.png'
                    className='imggshade'
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1 }}
                    viewport={{ once: false }}
                    alt='background shade'
                />

                {/* Background Video */}
                <motion.video
                    className='main-banner-video'
                    muted
                    playsInline
                    autoPlay
                    loop
                    width="100%"
                    id="myVideo"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 1.2 }}
                    viewport={{ once: false }}
                >
                    <source src="/assets/bottomvideo.mp4" type="video/mp4" />
                </motion.video>

                <div className='custom-containe1r'>
                    <motion.div
                        className='inner_work'
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: false }}
                    >
                        <h2>Ready to Modernize Your Workflows?</h2>

                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2, duration: 0.6 }}
                            viewport={{ once: false }}
                        >
                            Let’s talk about how we can secure and streamline your operations.
                        </motion.p>

                        <motion.div
                            className='buttons_div'
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.4, duration: 0.6 }}
                            viewport={{ once: false }}
                        >
                            <ScheduleButton />
                            {/* <button className='two'>Explore Portfolio</button> */}
                        </motion.div>
                    </motion.div>
                </div>
            </section>

        </>
    )
}

export default Managed
